import React, { Fragment, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import HomePage from '../pages/HomePage';
import CustomPage from '../pages/CustomPage';
import BlogPage from "../pages/BlogPage";
import ArticlePage from "../pages/ArticlePage";
import {AppContainer, getPublicImagePath, notifySuccess, SubscriptionModal, useAppState} from "@nutastic/nutastic-react-app";
import ComingSoonPage from "../pages/ComingSoonPage";
import ServicesPage from "../pages/ServicesPage";
import SubscriptionPage from "../pages/SubscriptionPage";
//TODO: make a "renderOnRoutes" component

const App = () => {
    const { subscribeFormText } = useAppState();
    const urlQueryString = window.location.search;
    const urlParams = new URLSearchParams(urlQueryString);
    const hasFormSentUrlParam = urlParams.get('formSent');

    useEffect(() => {
        if(hasFormSentUrlParam) notifySuccess("Your form was successfully submitted"); //TODO: fix this correctly in the forms nu-engine setup
    }, []);

    const renderPageRoute = () => {
        return <Switch>
            <Route path='/' exact={true} component={HomePage}/>
            <Route path='/home' component={HomePage}/>
            <Route path='/services' component={ServicesPage}/>
            <Route path='/blog/:slug' component={BlogPage}/>
            <Route path='/blog' component={BlogPage}/>
            <Route path='/article/:slug' component={ArticlePage}/>
            <Route path='/page/:slug' component={CustomPage}/>
            <Route path='/subscribe' component={SubscriptionPage}/>
            <Route path='/coming-soon-page' component={ComingSoonPage}/>
        </Switch>;
    };

    return <AppContainer>
        <Header />
        { renderPageRoute() }
        <Route render={({ location }) => ['/', '/home'].includes(location.pathname) ? null : <Footer/> }/>
        <Route render={({ location }) => ['/subscribe'].includes(location.pathname) ? null : <SubscriptionModal
            image={ getPublicImagePath('homeImage.jpg') }
            content={ subscribeFormText }
            onSubmit={ () => alert( `Thank you for subscribing to the newsletter!`) }
        /> }/>
    </AppContainer>;
};

export default App;
